import React from "react";
import "../App.css";
import { Link } from "react-scroll";
import { useState } from "react";
// import "aos/dist/aos.css"; // Import the AOS styles
// import AOS from "aos";

export default function Navbar({ isDarkMode, toggleTheme }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleThemeChanger = () => {
    toggleTheme();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleDownload = (e) => {
    e.preventDefault();
    const link = document.createElement("a");
    link.href = "/CV/MahinMalek_Resume.pdf";
    link.download = "MahinMalek_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.open("/CV/MahinMalek_Resume.pdf", "_blank");
  };
  const CreateLI = ({ text, scrollPage }) => {
    return (
      <>
        <Link
          activeClass="active"
          to={scrollPage}
          spy={true}
          smooth={true}
          offset={-60}
          duration={500}
        >
          <li
            className={`font-bold hover:rounded-md cursor-pointer hover:bg-common-red hover:text-white p-2 px-3 transition-all duration-500`}
            onClick={toggleDropdown}
          >
            {text}
          </li>
        </Link>
      </>
    );
  };

  const AllLI = () => {
    return (
      <>
        <CreateLI text="HOME" scrollPage="HOME" />
        <CreateLI text="ABOUT" scrollPage="ABOUT" />
        <CreateLI text="SKILLS" scrollPage="SKILLS" />
        <CreateLI text="WORK" scrollPage="WORK" />
        <CreateLI text="STATICS" scrollPage="STATICS" />
        <CreateLI text="PROJECTS" scrollPage="PROJECTS" />
        <CreateLI text="CONTACT" scrollPage="CONTACT" />
      </>
    );
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 flex justify-between items-center h-18 p-3 bg-gray-light z-50 bg-opacity-10 backdrop-blur-sm dark:text-white">
        <div>
          <h1 className="text-4xl font-Lemon">
            MA<span className="text-common-red">HIN</span>
          </h1>
        </div>
        <div className="lg:w-[65%] font-Arimo sm:w-max sm:px-4 md:w-[80%]">
          <i
            className="fa-solid fa-bars md:hidden sm:flex text-2xl"
            onClick={toggleDropdown}
          ></i>
          {isDropdownOpen && (
            <div className="md:hidden absolute grid items-center left-0 w-screen text-center h-screen bg-gray-light dark:text-white dark:bg-[#000983] shadow-md bg-opacity-95 backdrop-blur-lg">
              <ul className="h-1/2">
                <AllLI />
                <i
                  className={`${
                    isDarkMode
                      ? "fa-solid fa-moon icon-animation"
                      : "fa-regular fa-sun"
                  } text-2xl hover:cursor-pointer`}
                  onClick={handleThemeChanger}
                ></i>
              </ul>
            </div>
          )}
          <ul className="hidden md:flex justify-evenly items-center font-semibold text-base">
            <AllLI />
            <a
              href="/CV/MahinMalek_Resume.pdf"
              target="_blank"
              rel="noopener noreferrer"
              download="MahinMalek_Resume.pdf"
              onClick={handleDownload}
            >
              <li className="font-bold cursor-pointer hover:bg-common-red hover:text-white p-2 px-3 hover:rounded-md transition-all duration-500">
                RESUME
              </li>
            </a>
            <i
              className={`${
                isDarkMode
                  ? "fa-solid fa-moon icon-animation"
                  : "fa-regular fa-sun"
              } text-2xl hover:cursor-pointer`}
              onClick={handleThemeChanger}
            ></i>
          </ul>
        </div>
        {/* {isVisible && (
          <div
            className={`absolute right-2 top-16 p-2 justify-center hidden md:grid transition-transform duration-1000 ease-in-out`}
            data-aos="fade-left"
            data-aos-anchor-placement="top-bottom"
          >
            <i className="fa-solid fa-angles-up m-auto text-xl"></i>
            <div className=" p-2 rounded-md ">
              <p className="border-b-4 border-common-red font-Ubuntu font-medium">
                Look Here!
              </p>
            </div>
          </div>
        )} */}
      </nav>
    </>
  );
}
